import template from './swag-cms-extensions-custom-form-element.html.twig';
import './swag-cms-extensions-custom-form-element.scss';

const { Criteria } = Shopware.Data;

export default {
    template,

    inject: [
        'repositoryFactory',
    ],

    mixins: [
        'cms-element',
    ],

    data() {
        return {
            loadedGroups: [],
        };
    },

    computed: {
        groupRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_form_group');
        },

        showPreview() {
            return this.groups.length !== 0;
        },

        slotHasFormExtension() {
            return (
                this.element.extensions &&
                this.element.extensions.swagCmsExtensionsForm
            );
        },

        slotHasGroups() {
            return (
                this.slotHasFormExtension &&
                this.element.extensions.swagCmsExtensionsForm &&
                Array.isArray(this.element.extensions.swagCmsExtensionsForm.groups) &&
                this.element.extensions.swagCmsExtensionsForm.groups.length > 0
            )
        },

        groups() {
            if (this.slotHasGroups) {
                return this.element.extensions.swagCmsExtensionsForm.groups;
            }

            return this.loadedGroups;
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.loadForm();
        },

        loadForm() {
            this.loadedGroups = [];

            if (this.slotHasFormExtension && this.element.extensions.swagCmsExtensionsForm.id !== null) {
                const criteria = new Criteria();
                criteria.addFilter(
                    Criteria.equals('formId', this.element.extensions.swagCmsExtensionsForm.id),
                );
                criteria.addAssociation('fields');
                criteria.addSorting(Criteria.sort('position'));
                criteria.getAssociation('fields').addSorting(Criteria.sort('position'));

                this.groupRepository.search(criteria, Shopware.Context.api).then((result) => {
                    this.loadedGroups = result;
                });
            }
        },

        getFieldClass(field) {
            return [`swag-cms-extensions-custom-form-element__field-col-${field.width}`];
        },

        getFieldComponent(field) {
            const componentName = `swag-cms-extensions-custom-form-element-${field.type}`;

            if (!Shopware.Component.getComponentRegistry().has(componentName)) {
                return null;
            }

            return componentName;
        },
    },
}
